/**
 * Calculates the height for the dynamic part of your item.
 * You need to add the height of the fixed elements (if any)
 *  of your item to this height to get the final height.
 *
 * It requires some inputs to be manually calculated because we
 *  can't make any assumptions about the layout of the item.
 *
 *  Note that this is for the general case of an item with some dynamic
 *    text. If you have a crazy item layout, this function may not work
 *    and you might have to create an equivalent for your layout specifically.
 *
 */
export const comboboxDynamicTextContainerItemHeight = (args: {
  /**
   * Width of the container that holds the dynamic text.
   *
   * Note that this is not the width of the combobox and
   *  not necessarily the width of an entire item, it
   *  entirely depends on your layout.
   */
  containerWidth: number;
  minContainerWidth: number;

  /**
   * If you're having trouble with white space causing extra lines
   *  which causes this calculation to be a bit off, you can always
   *  lower this value to add a margin for error in the height. It's
   *  better to be more spacious than required vs being so tight
   *  that text overflows into other items.
   */
  maxCharactersPerMinContainerWidth: number;

  /**
   * Height of a single line of text.
   */
  lineHeight: number;
  /**
   * Character count of the dynamic text in your item.
   */
  characterCount: number;
}) => {
  const blocksToFit = Math.max(
    1,
    args.characterCount / args.maxCharactersPerMinContainerWidth
  );

  const blocksPerUnitHeight = Math.max(
    1,
    args.containerWidth / args.minContainerWidth
  );

  const height =
    Math.max(1, blocksToFit / blocksPerUnitHeight) * args.lineHeight;

  return height;
};
